import React from 'react';
import { BodyWeight } from 'components';

export const WeightOverview = () => {
    return <BodyWeight />;
};